export class ProfileItemDisplayObject {
    header: string;
    content: string[];
}
export class ProfileItemModel {
    heading: string;
    content: string  | ProfileItemDisplayObject[];

    constructor(heading: string, content: string  | ProfileItemDisplayObject[]) {
        this.heading = heading;
        this.content = content;
    }
}
